module.exports = __webpack_public_path__ + "static/media/iteration-x-128x128.939d3ec6.png";